import React, { useEffect, useState } from 'react';
import { Badge, Button, Col, Container, Form, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import "../../../../node_modules/react-datepicker/dist/react-datepicker.css";
import * as Common from "../../Common";
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from "../../Picklist";

import { faCopy, faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { faDownload } from '@fortawesome/free-solid-svg-icons/faDownload';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import ActivityLog from '../../ActivityLog';
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import Master_ledger_commission from './Master_ledger_commission';
import Master_ledger_documents from './Master_ledger_documents';
import Master_ledger_location from './Master_ledger_location';

function Master_voucher_ledger_view() {
    // const taxClassOPtions = [{ value: 0, label: "Select" },
    // { value: 1, label: "Gst" },
    // { value: 2, label: "Unregistered" },
    // { value: 3, label: "Gst Excluded" },
    // { value: 4, label: "SEZ" }
    // ];
    const right = 'VOUCHERLEDGERVIEW';
    const sid = sessionStorage.getItem("sessionId");
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    // const [userUploadRight, setUserUploadRight] = useState([]);
    const navigate = useNavigate();
    const [visiblePg, setVisiblePg] = useState("");

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [ldgSrno, setLdgSrno] = useState("");
    const [ldgName, setLdgName] = useState("");
    const [ldgLegalName, setLdgLegalName] = useState("");
    const [grpCode, setGrpCode] = useState("");
    const [ldgAddress, setLdgAddress] = useState("");
    const [ldgPinCode, setLdgPinCode] = useState("");
    const [ldgRbiLicense, setLdgRbiLicense] = useState("");
    const [ldgLastReviewDate, setLdgLastReviewDate] = useState(new Date());
    const [ldgWebsite, setLdgWebsite] = useState("");
    const [ldgValidity, setLdgValidity] = useState(new Date());
    const [ldgScope, setLdgScope] = useState("");
    const [ldgStatus, setLdgStatus] = useState("1");
    const [ldgMvliCard, setLdgMvliCard] = useState("1");

    /*########### Taxation ##################*/
    const [ldgGst, setLdgGst] = useState("1");
    const [ldgARN, setLdgARN] = useState("");
    const [ldgTds, setLdgTds] = useState("");
    const [ldgPan, setLdgPan] = useState("");
    const [ldgAadhar, setLdgAadhar] = useState("");
    const [ldgUIN, setLdgUIN] = useState("");
    const [ldgServiceCharge, setLdgServiceCharge] = useState("1");
    const [ldgGstin, setLdgGstin] = useState("");
    const [ldgGstExemptionDate, setLdgGstExemptionDate] = useState(null);
    const [ldgServiceChargeVal, setLdgServiceChargeVal] = useState("");


    /*########### Risk ##################*/
    const [ldgCreditAllow, setLdgCreditAllow] = useState(0);
    const [ldgCreditLimit, setldgCreditLimit] = useState("");
    const [ldgCreditPeriod, setldgCreditPeriod] = useState("");
    const [ldgExpectedVolLow, setLdgExpectedVolLow] = useState("");
    const [ldgExpectedVolMedium, setLdgExpectedVolMedium] = useState("");
    const [ldgExpectedVolHigh, setLdgExpectedVolHigh] = useState("");

    /*########### Additional ##################*/
    const [ldgPhone, setLdgPhone] = useState("");
    const [ldgMobile, setLdgMobile] = useState("");
    const [ldgEmail, setLdgEmail] = useState("");
    const [ldgListedIn, setLdgListedIn] = useState("");
    const [ldgBeneOwner, setLdgBeneOwner] = useState("");
    const [ldgBeneMobile, setLdgBeneMobile] = useState("");
    const [ldgBankAccNum, setLdgBankAccNum] = useState("");
    const [ldgBankName, setLdgBankName] = useState("");
    const [ldgFundSource, setLdgFundSource] = useState("");
    const [ldgPaymentMode, setLdgPaymentMode] = useState("");
    const [ldgSocialStatus, setLdgSocialStatus] = useState("");


    /*########### Options ##################*/
    const [ldgCountry, setLdgCountry] = useState({ value: 0, label: "Select" });
    const [ldgState, setLdgState] = useState({ value: 0, label: "Select" });
    const [ldgDistrict, setLdgDistrict] = useState({ value: 0, label: "Select" });
    const [ldgCity, setLdgCity] = useState({ value: 0, label: "Select" });
    const [ldgDealer, setLdgDealer] = useState({ value: 0, label: "Select" });
    const [ldgGroup, setLdgGroup] = useState({ value: 0, label: "Select" });
    const [ldgTaxclassOptions, setLdgTaxclassOptions] = useState([{ value: 0, label: "Select" }]);
    // const a ={ value: '1', label: '1 GST CUSTOMER' }
    const [ldgMSMEOptions, setLdgMSMEOptions] = useState([{ value: 0, label: "Select" }, { value: 1, label: "Dummy" }]);
    const [ldgRiskOptions, setLdgRiskOptions] = useState([]);
    const [ldgLegalOptions, setLdgLegalOptions] = useState([{ value: 0, label: "Select" }, { value: 1, label: "Dummy" }]);
    const [ldgNatureStatusOptions, setLdgNatureStatusOptions] = useState([]);
    const [ldgAccManagerOptions, setLdgAccManagerOptions] = useState([{ value: 0, label: "Select" }, { value: 1, label: "Dummy" }]);

    const [ldgCountryOptions, setLdgCountryOptions] = useState([]);
    const [ldgStateOptions, setLdgStateOptions] = useState([]);
    const [ldgDistrictOptions, setLdgDistrictOptions] = useState([]);
    const [ldgCityOptions, setLdgCityOptions] = useState([]);
    const [ldgDealerOptions, setLdgDealerOptions] = useState([]);
    // const [ldgGroupOptions, setLdgGroupOptions] = useState([]);
    const [ldgTaxclass, setLdgTaxclass] = useState({ value: 0, label: "Select" });
    const [ldgMSME, setLdgMSME] = useState({ value: 0, label: "Select" });
    const [ldgRisk, setLdgRisk] = useState({ value: 0, label: "Select" });
    const [ldgLegalStatus, setLdgLegalStatus] = useState({ value: 0, label: "Select" });
    const [ldgNatureStatus, setLdgNatureStatus] = useState({ value: 0, label: "Select" });
    const [ldgAccManager, setLdgAccManager] = useState({ value: 0, label: "Select" });

    const [ledgerList, setLedgerList] = useState([]);
    const [disableGroupOptions, setDisableGroupOptions] = useState(false);

    const [groupTypeOptions, setGroupTypeOptions] = useState([]);
    // const [groupType, setGroupType] = useState('');
    const [listType, setListType] = useState({ value: "ALL", label: "All" });

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [ledgerDocument, setLedgerDocument] = useState([]);
    const [commissionList, setCommissionList] = useState([]);
    const [locationLink, setLocationLink] = useState([]);
    const [bankAccNo, setBankAccNo] = useState("");
    const [bankIfsc, setBankIfsc] = useState("");
    const [ldgBankOptions, setLdgBankOptions] = useState([])
    const [ldgBank, setLdgBank] = useState({ value: 0, label: "Select" });
    const [fxGroup, setFxGroup] = useState('');
    const [fxAccount, setFxAccount] = useState('')

    // const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    //WALKIN CREDIT LIMIT
    const [crdLmtBranch, setCrdLmtBranch] = useState();
    const [crdLmtAmount, setCrdLmtAmount] = useState();
    // const [crdLmtSrno, setCrdLmtSrno] = useState(0);
    const [crdLmtDays, setCrdLmtDays] = useState();
    const [walkinCreditLimitList, setWalkinCreditLimitList] = useState([]);
    const [walkinCreditLimitListlength, setWalkinCreditLimitListlength] = useState(0);
    const [bankOneLocation, setBankOneLocation] = useState(null);

    const [nFile, setNFile] = useState("");
    // const [filterformatUpload, setFilterformatUpload] = useState("F");
    // const [showUploadButton, setShowUploadButton] = useState(false);

    const [bankLocationValue, setBankLocationValue] = useState(null);
    const [filterLdgGroup, setFilterLdgGroup] = useState([]);
    const [filterGrpCode, setFilterGrpCode] = useState('');
    const [compareDataInfo, setCompareDataInfo] = useState([]);
    // const [compareDataTax, setCompareDataTax] = useState([]);
    // const [compareDataRisk, setCompareDataRisk] = useState([]);
    // const [compareDataAdditional, setCompareDataAdditional] = useState([]);

    const [gstinVerifyTimestamp, setGstinVerifyTimestamp] = useState("");
    const [ldgGstinPrev, setLdgGstinPrev] = useState("");
    const [ldgInceptionDate, setLdgInceptionDate] = useState(new Date());
    const [ldgblacklisted, setLdgBlacklisted] = useState("");
    const [ldgActivationTillDate, setLdgActivationTillDate] = useState("");
    const [isApiCalled, setIsApiCalled] = useState("0");
    const [asyncTdsVal, setAsyncTdsVal] = useState();
    const [tdsSrno, setTdsSrno] = useState(0);

    const [ldgRbiLicenseDate, setLdgRbiLicenseDate] = useState(new Date());
    const [fxCINNumber, setFxCINNumber] = useState('');
    const [copyLedgerData, setCopyLedgerData] = useState(null);
    const [copyLedgerDataRight, setCopyLedgerDataRight] = useState(null);
    const [isCopyMsgBoxYN, setCopyMsgBoxYN] = useState(false);
    const [copyMsgTextYN, setCopyMsgTextYN] = useState("");
    const [scoperChangeRight, setScoperChangeRight] = useState(null);
    const [searchFilter, setSearchFilter] = useState('');




    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', right], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiLedgerView, [sid, "getoptions"], result => {
                        let resp = JSON.parse(result);
                        //setLdgGroupOptions(resp.group);
                        setLdgDealerOptions(resp.dealer);
                        setLdgCountryOptions(resp.country);
                        setLdgNatureStatusOptions(resp.businessnature);
                        setLdgRiskOptions(resp.risk);
                        setLdgLegalOptions(resp.legal);
                        setLdgMSMEOptions(resp.msme);
                    });
                    Common.callApi(Common.apiLedgerView, [sid, "distinctgrouptype"], result => {
                        setGroupTypeOptions(JSON.parse(result));
                    });
                } else {
                    navigate('/'); // no query right
                }
            });
            // Common.callApi(Common.apiRight, [sid, 'all', 'VOUCHERLEDGER_UPLOAD'], function (result) {
            //     let resp = JSON.parse(result);
            //     if (resp.query === "1") {
            //         setUserUploadRight(resp);
            //     }
            // })
            //get GST Classification List
            Common.callApi(Common.apiGstClassification, [sid, 'applicableGstOption'], function (result) {
                let resp = JSON.parse(result);
                setLdgTaxclassOptions(resp);
            })
            //copy ledger right
            // Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_VOUCHER_LEDGER_COPY'], function (result) {
            //     let resp = JSON.parse(result);
            //     if (resp.query === "1") {
            //         setCopyLedgerDataRight(resp);
            //     }
            // })
            // Common.callApi(Common.apiRight, [sid, 'all', 'MASTER_VOUCHER_LEDGER_SCOPE_CHANGE'], function (result) {
            //     let resp = JSON.parse(result);
            //     if (resp.query === "1") {
            //         setScoperChangeRight(resp);
            //     }
            // })
            setOnceRun(true);
        }
    }, [onceRun]);

    const getLedgerList = () => {
        $(".loader").show();
        const obj = {
            type: listType.value,
            search: searchFilter,
        }
        if (listType.value === 'OTHER' && filterGrpCode) {
            obj.filterGroupCode = filterGrpCode
        } else if (listType.value != 'OTHER') {
            setFilterGrpCode('')
        }
        Common.callApi(Common.apiLedgerView, [sid, "getlist", JSON.stringify(obj)], result => {
            $(".loader").hide();
            setLedgerList(JSON.parse(result));
        });
    }

    const handleLdgGroupValue = (value) => {
        setLdgGroup(value);
        const grpcd = value.id.split('^');
        setGrpCode(grpcd[1]);
    }

    function handleFilterLdgGroupValue(value) {
        console.log(value);
        setFilterLdgGroup(value);
        const grpcd = value.id.split('^');
        setFilterGrpCode(grpcd[1]);
        console.log("Filter Group Code", grpcd[1]);
    }

    // const getGroupVal = () => {
    //     Common.callApi(Common.apiLedgerView, [sid, "getgroupval", listType.value], result => {
    //         let resp = JSON.parse(result);
    //         setLdgGroupOptions(resp);
    //         if (resp.length > 1) {
    //             setDisableGroupOptions(false);
    //             setLdgGroup({ id: '^0^SELECT^0^SELECT^', label: 'Select' });
    //             setGrpCode(0);
    //         } else {
    //             setLdgGroup(resp);
    //             setDisableGroupOptions(true);
    //             setGrpCode(resp[0].id.split('^')[1]);
    //         }

    //         /*
    //             Common.callApi(Common.apiLedgerView, [sid, "getgroupval", listType.value], result => {
    //                 let resp = JSON.parse(result);
    //                 console.log(resp);
    //                 const grpcd = resp.value.split('^');
    //                 setGrpCode(grpcd[1]);
    //             });
    //         */
    //         // {id: '^1500^RESERVE AND SURPLUS^1500^OTHER^', label: '1500 RESERVE AND SURPLUS 1500 OTHER'}

    //     });
    // }

    // const addNewForm = () => {
    //     if (listType.value == 'ALL') {
    //         setMsgBox(true);
    //         setMsgText("Please select list type.");
    //     } else {
    //         //if (listType.value == 'AGENT' || listType.value == 'DEALER' || listType.value == 'CORPORATE') {
    //         setVisiblePg("A");
    //         getGroupVal();

    //     }
    //     setLdgSrno(0);
    //     setLdgAddress("");
    //     setLdgName("");
    //     setLdgLastReviewDate(new Date());
    //     setLdgValidity(new Date());
    //     setLdgPinCode("");
    //     setLdgRbiLicense("");
    //     setLdgWebsite("");
    //     setLdgScope("G");
    //     setLdgStatus("1");
    //     setLdgLegalName("");

    //     setLdgPan("");
    //     setLdgTds("");
    //     setLdgGst("1");
    //     setLdgGstin("");
    //     setLdgGstExemptionDate(null);
    //     setLdgARN("");
    //     setLdgUIN("");
    //     setLdgAadhar("");
    //     setLdgMSME({ value: 0, label: "Select" });
    //     setLdgServiceCharge("0");

    //     setLdgCreditAllow(0);
    //     setldgCreditLimit("");
    //     setldgCreditPeriod("");
    //     setLdgRisk({ value: 1, label: "LOW" });
    //     setLdgLegalStatus({ value: 0, label: "Select" });
    //     setLdgNatureStatus({ value: 0, label: "Select" });
    //     setLdgExpectedVolHigh("");
    //     setLdgExpectedVolMedium("");
    //     setLdgExpectedVolLow("");

    //     setLdgPhone("");
    //     setLdgMobile("");
    //     setLdgEmail("");
    //     setLdgListedIn("");
    //     setLdgBeneOwner("");
    //     setLdgBeneMobile("");
    //     setLdgBankName("");
    //     setLdgBankAccNum("");
    //     setLdgFundSource("");
    //     setLdgPaymentMode("");
    //     setLdgSocialStatus("");

    //     setLdgDistrict({ value: 0, label: "Select" });
    //     setLdgCountry({ value: 0, label: "Select" });
    //     setLdgCity({ value: 0, label: "Select" });
    //     setLdgState({ value: 0, label: "Select" });
    //     setLdgDealer({ value: 0, label: "Select" });
    //     setLdgTaxclass({ value: 0, label: "Select" });
    //     setLdgAccManager({ value: 0, label: "Select" });
    //     setLdgBank({ value: 0, label: "Select" });
    //     setFxAccount("");
    //     setFxGroup('');
    //     setBankAccNo('');
    //     setBankIfsc('');
    //     setLdgServiceChargeVal("");
    //     setBankOneLocation("");
    //     setBankLocationValue(null);
    //     setGstinVerifyTimestamp("");
    //     setLdgGstinPrev("");
    //     setLdgActivationTillDate("");
    //     setLdgBlacklisted("");
    //     setIsApiCalled("0");
    //     setAsyncTdsVal(null);
    //     if (listType.value == 'BANK') {
    //         getBankOption();
    //     }
    //     if (listType.value == 'WALKIN') {
    //         setWalkinCreditLimitListlength(0);
    //         setWalkinCreditLimitList([]);
    //     }
    //     setLdgRbiLicenseDate(new Date());
    //     setFxCINNumber('');
    //     setSearchFilter('');
    // }
    // const getTranAuditTrail = (obj) => {
    //     const infoObject = Common.compareArrays(compareDataInfo, [obj]);
    //     const taxation = Common.compareArrays(compareDataTax, [obj]);
    //     const risk = Common.compareArrays(compareDataRisk, [obj]);
    //     const additional = Common.compareArrays(compareDataAdditional, [obj]);

    //     if (userRight.edit === "1" && visiblePg === "E") {
    //         const auditObjectAddInfo = {
    //             TabType: "Info",
    //             ALineNo: tranAuditTrail.length + 1,
    //             TType: "MVLGD",
    //             AType: "A",
    //         };

    //         const auditObjectDeleteInfo = {
    //             TabType: "Info",
    //             ALineNo: tranAuditTrail.length + 1,
    //             TType: "MVLGD",
    //             AType: "D",
    //         };
    //         // const auditObjectAddTax = {
    //         //     TabType: "Tax",
    //         //     ALineNo: tranAuditTrail.length + 1,
    //         //     TType: "MVLGD",
    //         //     AType: "A",
    //         // };

    //         // const auditObjectDeleteTax = {
    //         //     TabType: "Tax",
    //         //     ALineNo: tranAuditTrail.length + 1,
    //         //     TType: "MVLGD",
    //         //     AType: "D",
    //         // };
    //         // const auditObjectAddRisk = {
    //         //     TabType: "Risk",
    //         //     ALineNo: tranAuditTrail.length + 1,
    //         //     TType: "MVLGD",
    //         //     AType: "A",
    //         // };

    //         // const auditObjectDeleteRisk = {
    //         //     TabType: "Risk",
    //         //     ALineNo: tranAuditTrail.length + 1,
    //         //     TType: "MVLGD",
    //         //     AType: "D",
    //         // };
    //         // const auditObjectAddAdditional = {
    //         //     TabType: "Additional",
    //         //     ALineNo: tranAuditTrail.length + 1,
    //         //     TType: "MVLGD",
    //         //     AType: "A",
    //         // };

    //         // const auditObjectDeleteAdditional = {
    //         //     TabType: "Additional",
    //         //     ALineNo: tranAuditTrail.length + 1,
    //         //     TType: "MVLGD",
    //         //     AType: "D",
    //         // };

    //         // const combinedObjectValue1Tax = {
    //         //     ...taxation.added,
    //         //     ...auditObjectAddTax,
    //         // };
    //         // const combinedObjectValue2Tax = {
    //         //     ...taxation.deleted,
    //         //     ...auditObjectDeleteTax,
    //         // };
    //         // setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue1Tax));
    //         // setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue2Tax));
    //         // const combinedObjectValue1Risk = {
    //         //     ...risk.added,
    //         //     ...auditObjectAddRisk,
    //         // };
    //         // const combinedObjectValue2Risk = {
    //         //     ...risk.deleted,
    //         //     ...auditObjectDeleteRisk,
    //         // };
    //         // setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue1Risk));
    //         // setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue2Risk));
    //         // const combinedObjectValue1Additional = {
    //         //     ...additional.added,
    //         //     ...auditObjectAddAdditional,
    //         // };
    //         // const combinedObjectValue2Additional = {
    //         //     ...additional.deleted,
    //         //     ...auditObjectDeleteAdditional,
    //         // };
    //         // setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue1Additional));
    //         // setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue2Additional));
    //         const combinedObjectValue1Info = {
    //             ...infoObject.added,
    //             ...auditObjectAddInfo,
    //         };
    //         const combinedObjectValue2Info = {
    //             ...infoObject.deleted,
    //             ...auditObjectDeleteInfo,
    //         };
    //         setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue1Info));
    //         setTranAuditTrail(Common.arrayAddItem(tranAuditTrail, combinedObjectValue2Info));
    //     }
    // }

    // const saveData = () => {
    //     $(".loader").show();
    //     var msg = [], i = 0;
    //     if (listType.value === "AGENT" || listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER") {
    //         if (ldgName.trim() === "" || ldgGroup.value == 0
    //             || (listType.value === "DEALER" && (ldgDealer.value == 0 || ldgRbiLicense == "" || ldgRbiLicenseDate === null)) || ldgLastReviewDate == ""
    //             || ldgValidity == "" || ldgScope === "" || ldgTaxclass.value == 0 || ldgPan === ""
    //             || ldgAddress === ""
    //             || (ldgCountry.value == 1 && (ldgState.value == 0 || ldgDistrict.value == 0 || !ldgPinCode))
    //             || ((listType.value === "CORPORATE" || listType.value === "DIVISION") && (ldgLegalStatus.value == 0 || ldgNatureStatus.value == 0)) // ldgMSME.value == 0 ||
    //             || ((ldgTaxclass.value == '1' || ldgTaxclass.value == '3' || ldgTaxclass.value == '4') && ldgGstin === "")
    //             || (ldgGst === '0' && ldgGstExemptionDate === null)
    //             || (ldgCreditAllow == 1 && (ldgCreditLimit == "" || ldgCreditPeriod == ""))
    //             || ldgRisk.value == 0 || (listType.value == "AGENT" && ldgTds === "") || (listType.value == "DEALER" && ldgDealer.value == 5 && ldgTds === "")
    //             || (listType.value == "DEALER" && ldgDealer.value == 7 && ldgTds === "" || ldgInceptionDate == "")
    //             || (listType.value === "DEALER" && (ldgExpectedVolMedium === "" || ldgExpectedVolHigh === "") || (ldgExpectedVolMedium * 1 > ldgExpectedVolHigh * 1))
    //             || ((listType.value === "CORPORATE" || listType.value === "DIVISION") && (ldgExpectedVolMedium === "" || ldgExpectedVolHigh === "") || (ldgExpectedVolMedium * 1 > ldgExpectedVolHigh * 1))
    //             || ((listType.value === "CORPORATE" || listType.value === "DEALER") && !ldgMobile)
    //         ) {
    //             msg[i++] = Common.getMessage("MSG0006");
    //             msg[i++] = (ldgGroup.id == '^0^SELECT^0^SELECT^' ? "Info-> Group." : '');
    //             msg[i++] = (ldgName.trim() === "" ? "Info-> Ledger Name." : '');
    //             msg[i++] = ((listType.value == "AGENT" && ldgTds === "") ? "Taxation-> TDS%." : '');

    //             msg[i++] = (ldgAddress === "" ? "Info-> Address." : '');
    //             msg[i++] = (ldgCountry.value == 0 ? "Info-> Country." : '');
    //             if (ldgCountry.value == 1) {//1 means india
    //                 console.log('ldgPinCode', ldgPinCode)
    //                 msg[i++] = (ldgState.value == 0 ? "Info-> State." : '');
    //                 msg[i++] = (ldgDistrict.value == 0 ? "Info-> District." : '');
    //                 msg[i++] = (!ldgPinCode ? "Info-> Pincode." : '');
    //             }
    //             msg[i++] = (ldgLastReviewDate === "" ? "Info->  Last review date." : '');
    //             msg[i++] = (ldgInceptionDate === "" ? "Taxation->  Inception date." : '');
    //             msg[i++] = (ldgValidity === "" ? "Info->  Validity." : '');
    //             msg[i++] = (ldgScope === "" ? "Info->  Scope." : '');
    //             if (listType.value === 'DEALER') {
    //                 msg[i++] = (ldgDealer.value == 0 ? "Info-> Dealer Type." : '');
    //                 msg[i++] = (ldgRbiLicense === "" ? "Info-> RBI License." : '');
    //                 msg[i++] = (ldgRbiLicenseDate === null ? "Info-> RBI License Date." : '');
    //                 if (ldgDealer.value == 5 || ldgDealer.value == 7) {
    //                     msg[i++] = (ldgTds === "" ? "Taxation-> TDS%." : '');
    //                 }
    //             }

    //             msg[i++] = (ldgTaxclass.value == "0" ? "Taxation-> Tax class." : '');
    //             msg[i++] = (ldgPan === "" ? "Taxation-> Pancard." : '');

    //             if ((ldgTaxclass.value == '1' || ldgTaxclass.value == '3' || ldgTaxclass.value == '4') && ldgGstin === "") {
    //                 msg[i++] = (ldgGstin === "" ? "Taxation-> GSTIN." : '');
    //             }

    //             if (ldgGst === "0") {
    //                 msg[i++] = (ldgGstExemptionDate === null ? "Taxation-> GST Exemption date." : '');
    //             }

    //             msg[i++] = (ldgRisk.value == 0 ? "Risk-> Risk." : '');
    //             if (listType.value === "CORPORATE" || listType.value === "DIVISION") {
    //                 // msg[i++] = (ldgMSME.value == "0" ? " MSME." : '');
    //                 msg[i++] = (ldgLegalStatus.value == "0" ? "Risk-> Legal Status." : '');
    //                 msg[i++] = (ldgNatureStatus.value == "0" ? "Risk-> Nature of business." : '');
    //             }
    //             if (ldgCreditAllow == 1) {
    //                 msg[i++] = (ldgCreditLimit == "" ? "Risk-> Credit limit." : '');
    //                 msg[i++] = (ldgCreditPeriod == "" ? "Risk-> Credit Period." : '');
    //             }
    //             // if (listType.value === "CORPORATE" || listType.value === "DEALER") {
    //             /*if (ldgPhone === "" || ldgMobile === "" || ldgEmail === "") {
    //                 msg[i++] = (ldgPhone === "" ? " Ledger Phone." : '');
    //                 msg[i++] = (ldgMobile === "" ? " Ledger Mobile." : '');
    //                 msg[i++] = (ldgEmail === "" ? " Ledger Email." : '');
    //             }*/
    //             // }
    //             if (listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "DIVISION") {
    //                 if (ldgExpectedVolMedium === "" || ldgExpectedVolHigh === "" || (ldgExpectedVolMedium * 1 > ldgExpectedVolHigh * 1)) {
    //                     msg[i++] = (ldgExpectedVolMedium === "" ? "Risk-> Expected Volume Medium." : '');
    //                     msg[i++] = (ldgExpectedVolHigh === "" ? " Risk->Expected Volume High." : '');
    //                     msg[i++] = ((ldgExpectedVolMedium * 1 > ldgExpectedVolHigh * 1) ? " Risk->Expected volume high should be greater then medium ." : '');
    //                 }
    //             }
    //             if ((listType.value === "CORPORATE" || listType.value === "DEALER") && (!ldgMobile || ldgPinCode === "")) {
    //                 msg[i++] = (!ldgMobile ? "Additional-> Mobile No." : '');
    //                 msg[i++] = (ldgPinCode === "" ? "Pin code ." : '');

    //             }
    //             $(".loader").hide();
    //             setMsgBox(true);
    //             setMsgText(Common.buildMessageFromArray(msg));
    //         }
    //     } else {
    //         if (listType.value === "WALKIN" && (ldgName === "" || ldgScope === "")) {
    //             msg[i++] = Common.getMessage("MSG0006");
    //             msg[i++] = (ldgName === "" ? " Ledger name." : '');
    //             msg[i++] = (ldgScope === "" ? " Scope." : '');
    //             $(".loader").hide();
    //             setMsgBox(true);
    //             setMsgText(Common.buildMessageFromArray(msg));
    //         } else if (listType.value === "BANK" && (bankAccNo == "" || bankIfsc == "" || ldgName === "" || ldgScope === ""
    //             || (ldgScope === "S" && bankLocationValue == null))) {
    //             msg[i++] = Common.getMessage("MSG0006");
    //             msg[i++] = (ldgName === "" ? " Ledger name." : '');
    //             msg[i++] = (bankAccNo == "" ? " Account Number." : '');
    //             msg[i++] = (bankIfsc == "" ? " Bank IFSC Code." : '');
    //             msg[i++] = (ldgScope === "" ? " Scope." : '');
    //             msg[i++] = ((ldgScope === "S" && bankLocationValue == null) ? "Info->  Location." : '');
    //             $(".loader").hide();
    //             setMsgBox(true);
    //             setMsgText(Common.buildMessageFromArray(msg));
    //         } else if (ldgName === "" || ldgGroup.id == '^0^SELECT^0^SELECT^' || ldgLastReviewDate === "" || ldgValidity === "" || ldgScope === "") {
    //             msg[i++] = Common.getMessage("MSG0006");
    //             msg[i++] = (ldgGroup.id == '^0^SELECT^0^SELECT^' ? " Group." : '');
    //             msg[i++] = (ldgName === "" ? " Ledger name." : '');
    //             msg[i++] = (ldgLastReviewDate === "" ? " Last review date." : '');
    //             msg[i++] = (ldgValidity === "" ? " Validity." : '');
    //             msg[i++] = (ldgScope === "" ? " Scope." : '');
    //             $(".loader").hide();
    //             setMsgBox(true);
    //             setMsgText(Common.buildMessageFromArray(msg));
    //         }
    //     }
    //     //to check gst number and pan number matching or not
    //     if (ldgPan && ldgGstin) {
    //         if (!ldgGstin.includes(ldgPan)) {
    //             msg[i++] = 'GSTIN is not matching with PAN Number ';
    //             $(".loader").hide();
    //             setMsgBox(true);
    //             setMsgText(Common.buildMessageFromArray(msg));
    //         }
    //     }

    //     if (msg.length == 0) {
    //         console.log(ldgLastReviewDate)
    //         console.log(Common.dateYMD(ldgLastReviewDate))

    //         const obj = {
    //             ldgName: ldgName,
    //             ldglegalName: ldgLegalName,
    //             ldgAddress: ldgAddress,
    //             ldgSrno: ldgSrno,
    //             ldgCity: ldgCity.value,
    //             ldgCountry: ldgCountry.value,
    //             ldgState: ldgState.value,
    //             ldgDistrict: ldgDistrict.value,
    //             ldgDealer: ldgDealer.value || 0,
    //             ldgGroup: grpCode,
    //             ldgPinCode: ldgPinCode,
    //             ldgValidity: Common.dateYMD(ldgValidity),
    //             ldgLastReviewDate: Common.dateYMD(ldgLastReviewDate),
    //             ldgWebsite: ldgWebsite,
    //             ldgStatus: ldgStatus,
    //             ldgMvliCard: ldgMvliCard,
    //             ldgScope: ldgScope,
    //             ldgRbiLicense: ldgRbiLicense,
    //             ldgRbiLicenseDate: Common.dateYMD(ldgRbiLicenseDate),
    //             ldgInceptionDate: Common.dateYMD(ldgInceptionDate),

    //             // taxation 
    //             //mvli_dealer,

    //             ldgPan: ldgPan,
    //             ldgTaxclass: ldgTaxclass?.value,
    //             ldgServiceCharge: ldgServiceCharge,
    //             ldgTds: (listType.value == "AGENT") || (listType.value == "DEALER" && ldgDealer.value == 5) || (listType.value == "DEALER" && ldgDealer.value == 7) ? ldgTds : "",
    //             ldgGst: ldgGst,
    //             ldgGstin: ldgGstin,
    //             ldgGstExemptionDate: Common.dateYMD(ldgGstExemptionDate),
    //             ldgARN: ldgARN,
    //             ldgUIN: ldgUIN,
    //             ldgAadhar: ldgAadhar,
    //             ldgMSME: ldgMSME.value || 0,
    //             ldgServiceChargeVal: ldgServiceChargeVal == "" || ldgServiceCharge == "0" ? 0 : ldgServiceChargeVal,
    //             ldgGstinPrev: ldgGstinPrev,
    //             //RISK

    //             ldgCreditAllow: ldgCreditAllow || 0,
    //             ldgCreditLimit: ldgCreditLimit || 0,
    //             ldgCreditPeriod: ldgCreditPeriod || 0,
    //             ldgRisk: ldgRisk.value || 0,
    //             ldgLegalStatus: ldgLegalStatus.value || 0,
    //             ldgNatureStatus: ldgNatureStatus.value || 0,
    //             // ldgExpectedVolLow: ldgExpectedVolLow,
    //             ldgExpectedVolLow: "0",
    //             ldgExpectedVolMedium: ldgExpectedVolMedium || 0,
    //             ldgExpectedVolHigh: ldgExpectedVolHigh || 0,

    //             //additional

    //             ldgPhone: ldgPhone,
    //             ldgMobile: ldgMobile,
    //             ldgEmail: ldgEmail,
    //             ldgListedIn: ldgListedIn,
    //             ldgBeneOwner: ldgBeneOwner,
    //             ldgBeneMobile: ldgBeneMobile,
    //             ldgAccManager: ldgAccManager.value || 0,
    //             ldgBankName: ldgBankName,
    //             ldgBankAccNum: listType.value === "BANK" ? bankAccNo : ldgBankAccNum,
    //             ldgFundSource: ldgFundSource,
    //             ldgPaymentMode: ldgPaymentMode,
    //             ldgSocialStatus: ldgSocialStatus,
    //             bankIfsc: bankIfsc || '',
    //             fxGroup: fxGroup ? fxGroup : 0,
    //             fxAccount: fxAccount ? fxAccount : 0,
    //             bankCode: ldgBank ? ldgBank : { value: "", label: "Select" },

    //             TabType: "INFO",
    //             ALineNo: tranAuditTrail.length + 1,
    //             AType: "A",
    //             TType: 'MVLGD',
    //             type: 'MVLGD',
    //             bankOneLocation: listType.value === "BANK" && ldgScope === "S" ? bankOneLocation : 0,
    //             listType: listType.value,
    //             commissionlist: commissionList,
    //             tdsSrno: tdsSrno,
    //             cinNumber: fxCINNumber,
    //         }
    //         //if listtype is walkin than walkincredit limitlist
    //         if (listType.value === "WALKIN") {
    //             obj.walkinCreditLimitList = walkinCreditLimitList;
    //         }
    //         getTranAuditTrail(obj);
    //         Common.callApi(Common.apiLedgerView, [sid, "savedata", JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
    //             $(".loader").hide();
    //             let resp = JSON.parse(result);
    //             if (resp.msg === "MSG0000") {
    //                 setVisiblePg("");
    //                 getLedgerList();
    //                 setTranAuditTrail([]);
    //                 setWalkinCreditLimitList([]);
    //                 setWalkinCreditLimitListlength(0);
    //                 if (resp.blacklistedYN?.isBlackListed && resp.blacklistedYN.isBlackListed === "1") {
    //                     setMsgText(resp.blacklistedYN.name + " saved with BLACKLISTED ledger." + resp.blacklistedYN.tsa_master + " " + resp.blacklistedYN.tsa_data_id);
    //                     setMsgBox(true);
    //                 }
    //                 // if (resp.blacklistedYN === "1") {
    //                 //     setMsgText("Entry saved with BLACKLISTED Ledger.");
    //                 //     setMsgBox(true);
    //                 // }
    //             } else if (resp.msg === "ERR0000") {
    //                 setMsgBox(true);
    //                 $(".loader").hide();
    //                 setMsgText(Common.getMessage(resp.err));
    //             } else {
    //                 $(".loader").hide();
    //                 setMsgBox(true);
    //                 setMsgText(resp.err);
    //             }
    //         });
    //     }
    // }

    const getStateOptions = (v) => {
        if (v.value) {
            Common.callApi(Common.apiLedgerView, [sid, "getstate", v.value], result => {
                setLdgStateOptions(JSON.parse(result));
            });
        }
    }

    const getDistrictOption = (v) => {
        if (v.value) {
            Common.callApi(Common.apiDistrict, [sid, "getdistrict", v.value], result => {
                setLdgDistrictOptions(JSON.parse(result));
            });
        }
    }

    const handleCountryChange = (v) => {
        setLdgCountry(v);
        setLdgState({ value: "0", label: "Select" });
        setLdgDistrict({ value: "0", label: "Select" });
        setLdgCity({ value: "0", label: "Select" });
        Common.callApi(Common.apiLedgerView, [sid, "getstate", v.value], result => {
            setLdgStateOptions(JSON.parse(result));
        });
    }

    const handleBankChange = (v) => {
        console.log('hello')
        setLdgBank(v);
    }

    const getBankOption = async () => {
        console.log("bank option")
        await Common.callApi(Common.apiLedgerView, [sid, "getBank"], result => {
            setLdgBankOptions(JSON.parse(result));
        });
    }

    const handleStateChange = (v) => {
        setLdgState(v);
        setLdgDistrict({ value: "0", label: "Select" });
        setLdgCity({ value: "0", label: "Select" });
        // Common.callApi(Common.apiLedgerView, [sid, "getcity", v.value], result => {
        //     setLdgCityOptions(JSON.parse(result));
        // });
        Common.callApi(Common.apiDistrict, [sid, "getdistrict", v.value], result => {
            setLdgDistrictOptions(JSON.parse(result));
        });
    }
    const compareDataObjectForAuditTrail = (resp) => {
        const info = {
            ldgName: resp.name,
            ldglegalName: resp.legalName,
            ldgAddress: resp.address,
            ldgCity: resp.city,
            ldgCountry: resp.country,
            ldgState: resp.state,
            ldgDistrict: resp.district,
            ldgDealer: { value: resp.dealer, label: resp.dealername },
            ldgGroup: { value: resp.group, label: resp.group + " " + resp.groupname },
            ldgPinCode: resp.pin,
            ldgValidity: resp.validity,
            ldgLastReviewDate: resp.lastreview,
            ldgWebsite: resp.website,
            ldgStatus: resp.status,
            ldgScope: resp.scope,
            ldgRbiLicense: resp.rbilic,
            // }
            // setCompareDataInfo([info]);
            // const taxation = {
            ldgPan: resp.pancard,
            ldgTaxclass: resp.taxclass,
            ldgServiceCharge: resp.servicecharge,
            ldgTds: resp.tds,
            ldgGst: resp.gst,
            ldgGstin: resp.gstin,
            ldgGstExemptionDate: resp.exemptiondate,
            ldgARN: resp.arn,
            ldgUIN: resp.uin,
            ldgAadhar: resp.aadhar,
            ldgMSME: resp.msme,
            ldgServiceChargeVal: resp.serviceAmount,
            // }
            // setCompareDataTax([taxation]);

            // const risk = {
            ldgCreditAllow: resp.creditallowed,
            ldgCreditLimit: resp.creditlimit,
            ldgCreditPeriod: resp.creditperiod,
            ldgRisk: resp.risk,
            ldgLegalStatus: resp.legalstatus,
            ldgNatureStatus: resp.businessnature,
            ldgExpectedVolLow: resp.expvolumelow,
            ldgExpectedVolMedium: resp.expvolumemed,
            ldgExpectedVolHigh: resp.expvolumehigh,
            // }
            // setCompareDataRisk([risk]);
            // const additional = {
            ldgPhone: resp.phone,
            ldgMobile: resp.mobile,
            ldgEmail: resp.email,
            ldgListedIn: resp.listedin,
            ldgBeneOwner: resp.beneowner,
            ldgBeneMobile: resp.benemobile,
            ldgAccManager: resp.amtmanager,
            ldgBankName: resp.bankname,
            ldgBankAccNum: resp.grouptype === "BANK" ? resp.accountnum : resp.accountnum,
            ldgFundSource: resp.fundsource,
            ldgPaymentMode: resp.paymentmode,
            ldgSocialStatus: resp.socialstatus,
            bankIfsc: resp.bankIfsc,
            fxGroup: resp.fxGroup ? resp.fxGroup : 0,
            fxAccount: resp.fxAccount ? resp.fxAccount : 0,
            bankCode: resp.bankCode ? { value: resp.bankCode, label: resp.bankName } : { value: "", label: "Select" },
        }
        // setCompareDataAdditional([additional]);
        setCompareDataInfo([info]);
    }

    const fillEditForm = (srno, groupsrno) => {
        $(".loader").show();
        setLdgSrno(srno);
        setVisiblePg("Q");
        setDisableGroupOptions(true);
        Common.callApi(Common.apiLedgerView, [sid, "details", srno, groupsrno], result => {
            let resp = JSON.parse(result);
            if (resp.msg === "MSG0000") {
                compareDataObjectForAuditTrail(resp);
                setLdgName(resp.name);
                setLdgLegalName(resp.legalName);
                setLdgAddress(resp.address);
                if (resp.country == 0 || resp.country === "" || resp.country === null) {
                    setLdgCountry({ value: 0, label: "Select" });
                } else {
                    setLdgCountry({ value: resp.country, label: resp.cntname });
                }
                if (resp.state == 0 || resp.state === "" || resp.state === null) {
                    getStateOptions({ value: 0, label: "Select" });
                } else {
                    setLdgState({ value: resp.state, label: resp.statename });
                }
                if (resp.city == 0 || resp.city === "" || resp.city === null) {
                    setLdgCity({ value: 0, label: "Select" });
                } else {
                    setLdgCity({ value: resp.city, label: resp.cityname });
                }
                setLdgDistrict({ value: resp.district, label: resp.distname });
                getDistrictOption({ value: resp.state, label: resp.statename })
                setLdgDealer({ value: resp.dealer, label: resp.dealername });
                setLdgRbiLicense(resp.rbilic);
                setLdgRbiLicenseDate(resp.rbilicdate ? new Date(resp.rbilicdate) : null);
                setLdgValidity(new Date(resp.validity));
                setLdgLastReviewDate(new Date(resp.lastreview));
                setLdgWebsite(resp.website);
                setLdgScope(resp.scope);
                setLdgStatus(resp.status);
                setLdgServiceCharge(resp.servicecharge);
                setLdgCreditAllow(resp.creditallowed);
                setldgCreditLimit(resp.creditlimit);
                setldgCreditPeriod(resp.creditperiod);
                setLdgExpectedVolLow(resp.expvolumelow);
                setLdgExpectedVolMedium(resp.expvolumemed ? resp.expvolumemed : "");
                setLdgExpectedVolHigh(resp.expvolumehigh ? resp.expvolumehigh : "");
                setLdgPhone(resp.phone);
                setLdgMobile(resp.mobile || "");
                setLdgEmail(resp.email);
                setLdgListedIn(resp.listedin);
                setLdgBeneOwner(resp.beneowner);
                setLdgBeneMobile(resp.benemobile);
                setLdgAccManager({ value: resp.amtmanager, label: "Select" });
                setLdgGroup({ value: resp.group, label: resp.group + " " + resp.groupname });
                setLdgBankName(resp.bankname);
                setLdgBankAccNum(resp.accountnum);
                setLdgFundSource(resp.fundsource);
                setLdgPaymentMode(resp.paymentmode);
                setLdgSocialStatus(resp.socialstatus);
                setGrpCode(resp.group);
                setListType({ value: resp.grouptype, label: resp.grouptype });
                setLdgMSME({ value: resp.msme, label: resp.msmedesc });
                setLdgPan(resp.pancard);
                setLdgTds(resp.tds === null ? "" : resp.tds);
                setTdsSrno(resp.mvli_tds_srno ? resp.mvli_tds_srno : 0);
                setAsyncTdsVal({ id: '^' + resp.mvli_tds_srno + '^' + resp.mt_section + '^' + resp.mt_rate_of_tds + '^', label: ' ' + resp.mt_section + ' ' + resp.mt_rate_of_tds + '%' })
                console.log(typeof resp.taxclass)
                if (resp.taxclass != 0) {
                    setLdgTaxclass(ldgTaxclassOptions.filter(val => val.value == resp.taxclass)[0]);
                } else {
                    setLdgTaxclass({ value: 0, label: "Select" })
                }
                setLdgGst(resp.gst);
                setLdgGstin(resp.gstin);
                setLdgGstinPrev(resp.gstin);
                if (resp.exemptiondate !== "") {
                    setLdgGstExemptionDate(new Date(resp.exemptiondate));
                }
                setLdgARN(resp.arn);
                setLdgUIN(resp.uin);
                setLdgAadhar(resp.aadhar);
                setLdgServiceCharge(resp.servicecharge);
                setLdgPinCode(resp.pin);
                setLdgLegalStatus({ value: resp.legalstatus, label: resp.legalstatusdesc });
                setLdgNatureStatus({ value: resp.businessnature, label: resp.businessnaturedesc });
                setLdgRisk({ value: resp.risk, label: resp.riskdesc });
                setOnceRun(false);
                setBankAccNo(resp.accountnum);
                setBankIfsc(resp.bankIfsc)
                setFxAccount(resp.fxAccount)
                setFxGroup(resp.fxGroup);

                //Ledger Document
                setLedgerDocument(resp.ledgerdocument);
                setCommissionList(resp.commissiondetail);
                setLocationLink(resp.locationlist);

                setLdgServiceChargeVal(resp.serviceAmount);

                setGstinVerifyTimestamp(resp.gstin_verify_timestamp);
                setLdgInceptionDate(new Date(resp.inceptionDate));
                setLdgBlacklisted(resp.blacklist);
                setLdgActivationTillDate(resp.activation_till_date);

                setIsApiCalled(resp.isapicalled);
                setFxCINNumber(resp.cinnumber);
                setLdgMvliCard(resp.mvli_card);

                if (resp.locid == null) setBankLocationValue(null);
                else {
                    setBankLocationValue({ id: resp.locid, label: resp.locname });
                    setBankOneLocation(resp.locid.split("^")[1]);
                }
                // getGroupVal();
                if (listType.value == 'BANK') {
                    console.log("bank")
                    getBankOption();
                    setLdgBank({ value: resp.bankCode, label: resp.bankName })
                }
                if (listType.value == 'WALKIN') {
                    const walkinList = resp?.walkincreditlist;
                    setWalkinCreditLimitListlength(walkinList?.length);
                    setWalkinCreditLimitList(walkinList.map((data, index) => {
                        return {
                            srno: data.srno,
                            branch: { id: '^' + data.branch.split(' ').join('^') + '^', label: data.branch },
                            creditdays: data.creditdays,
                            creditamount: data.creditamount,
                            creditdate: new Date(data.date),
                            tempsrno: index + 1,
                            isActive: 1
                        }
                    }))
                }
            }
            $(".loader").hide();
        });
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setVisiblePg("");
    }

    const cancelConfirm = () => {
        if (visiblePg === "A" || visiblePg === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    // const editFields = () => {
    //     setVisiblePg("E");
    // }

    const exportFile = () => {
        $(".loader").show();
        var obj = {
            right: right,
            type: listType.value,
            groupCode: filterGrpCode ? filterGrpCode : '',
            search: searchFilter,
        }
        Common.callDownloadApiPost1(Common.apiReport, "post", [sid, JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            setMsgText(result);
            setMsgBox(true);

        });
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        console.log("this is ledger group", ldgGroup.value)
        setLogObject({ trantype: "MVLGD", trannumber: ldgSrno, trancategory: "M", subtranno: ldgGroup.value });
    }

    //WALKIN CREDIT LIMIT 
    function walkinCreditLimitListHandler() {
        let i = 0, msg = [];
        msg[i++] = Common.getMessage("MSG0006");//i=1
        !crdLmtBranch && (msg[i++] = " Branch.");
        !crdLmtAmount && (msg[i++] = " Credit Amount.");
        !crdLmtDays && (msg[i++] = " Credit Days.");

        if (i > 1) {
            setMsgBox(true);
            setMsgText(Common.buildMessageFromArray(msg));
        } else {
            // if same entry alreasy present than deactivate previous one.
            const newCrediteList = walkinCreditLimitList.map((data) => {
                if (data.branch.id === crdLmtBranch.id) {
                    return {
                        ...data,
                        isActive: 0
                    };
                } else {
                    return data;
                }
            })
            //srno 0 means this is a new entry
            const obj = {
                srno: 0,
                tempsrno: walkinCreditLimitListlength + 1,
                branch: crdLmtBranch,
                creditamount: crdLmtAmount,
                creditdays: crdLmtDays,
                creditdate: new Date(),
                isActive: 1
            }
            setWalkinCreditLimitList([...newCrediteList, obj]);
            setWalkinCreditLimitListlength(prevValue => prevValue + 1);
            setCrdLmtAmount(0);
            setCrdLmtBranch({ id: '', label: '' });
            setCrdLmtDays(0);
        }
    }

    function deleteWalkinCreditItem(tempsrno) {
        const newArrayList = walkinCreditLimitList.map((data) => {
            if (data.tempsrno === tempsrno) {//data we want to delete 
                if (data.srno != 0) {
                    return { ...data, isActive: 0 }
                } else {
                    return;
                }
            } else if (data.tempsrno > tempsrno) {// update other tempsrno of above data 
                return { ...data, tempsrno: data.tempsrno - 1 }
            }
            return data;
        }).filter(Boolean);
        console.log(newArrayList);
        setWalkinCreditLimitList(newArrayList);
        setWalkinCreditLimitListlength((prevValue) => prevValue - 1);

    }

    const handleChangeBankLocation = (value) => {
        setBankLocationValue(value);
        setBankOneLocation(value.id.split("^")[1]);
    }

    // const handleFileChange = (v) => {
    //     setNFile(v);
    // }

    // const uploadFile = () => {
    //     $(".loader").show();
    //     var msg = [], i = 0;
    //     var selectedFile = document.getElementById('uploadEntries').files[0];
    //     if (selectedFile === undefined) {
    //         $('.loader').hide();
    //         setMsgText("Please select a file to upload.");
    //         setMsgBox(true);
    //     } else if ((selectedFile.name.split('.')).length > 2) {
    //         $('.loader').hide();
    //         setMsgText("(.) not allowed in file name.");
    //         setMsgBox(true);
    //     } else if (selectedFile.name.split('.')[1] !== "xlsx") {
    //         $('.loader').hide();
    //         setMsgText("File extension must be xlsx.");
    //         setMsgBox(true);
    //     } else if (selectedFile.size > 10 * 1024 * 1024) {  // 10 MB
    //         $('.loader').hide();
    //         setMsgText("Please select a file with in 10 MB size.");
    //         setMsgBox(true);
    //     } else {
    //         const obj = {
    //             sid: sid,
    //             pageright: "VOUCHERLEDGER_UPLOAD",
    //             uploadType: "uploadledgerdata",
    //             reportType: listType.value,
    //             filename: nFile,
    //         }
    //         Common.uploadApi(JSON.stringify(obj), "uploadEntries", (result) => {
    //             $(".loader").hide();
    //             let resp = JSON.parse(result);
    //             if (resp.error === 0) {
    //                 setMsgBox(true);
    //                 setMsgText(resp.errordata[0].desc);
    //                 setLedgerList(resp.ledgerList);
    //             } else if (resp.error == 1) {
    //                 Common.callApi(Common.apiLedgerView, [sid, "errorLedgerUploadData", JSON.stringify(resp.errordata)], response => {
    //                     var newWindow = window.open();
    //                     newWindow.document.write(response);
    //                 });
    //             } else {
    //                 setMsgBox(true);
    //                 setMsgText(resp.errordata[0].desc);
    //             }
    //             setNFile("");
    //             setShowUploadButton(!showUploadButton);
    //         });
    //     }
    // }
    // const downloadFormat = () => {
    //     $(".loader").show();
    //     var obj = {
    //         listtype: listType.value
    //     }
    //     Common.callDownloadApiPost1(Common.apiLedgerView, "post", [sid, 'LedgerUploadFormat', JSON.stringify(obj)], (result) => {
    //         $(".loader").hide();
    //         setMsgText(Common.buildMessageFromArray([result]));
    //         setMsgBox(true);
    //     });
    // }

    // const UploadLedgerData = () => {

    // }

    const handleDistrictChange = (v) => {
        setLdgDistrict(v);
        setLdgCity({ value: '0', label: "Select" });
        const obj = {
            district: v.value,
            state: ldgState.value
        }
        Common.callApi(Common.apiLedgerView, [sid, "getcity", JSON.stringify(obj)], result => {
            setLdgCityOptions(JSON.parse(result));
        });
    }
    const handleCommListUpdate = (updatedList) => {
        setCommissionList(updatedList);
    };

    const verifyGstin = () => {
        if (ldgGstin === "") {
            setMsgBox(true);
            setMsgText("Please fill gstin");
        } else {
            const obj = {
                ldgGstin: ldgGstin,
                ldgSrno: ldgSrno,
                ldgGroup: grpCode
            }
            $(".loader").show();
            Common.callApi(Common.apiLedgerView, [sid, "verifygstin", JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.msg === "MSG0000") {
                    setMsgBox(true);
                    setMsgText("Gstin Verified");
                    fillEditForm(ldgSrno, grpCode);
                } else {
                    setMsgBox(true);
                    setMsgText(resp.err);
                }
            });
        }
    }
    const tdsHandler = (val) => {
        console.log(val);
        setAsyncTdsVal(val)
        setTdsSrno(val.id.split('^')[1])//tds srno
        setLdgTds(val.id.split('^')[3]);// percentage

    }

    const onChangeListType = (val) => {
        setLedgerList([]);
        setListType(val);
    }

    const copyDetailHandler = (val) => {
        const obj = {
            srno: val.mvli_srno,
            group: val.mvli_group,
            ledgerName: val.mvli_ledger_name,
            ledgerLegalName: val.mvli_ledger_legal_name,
            type: listType.value,
        }
        setCopyLedgerData(obj);
        setCopyMsgBoxYN(true);
        setCopyMsgTextYN(`Do you really want to Create New Copy of ${listType.value} As ${val.mvli_ledger_name} ?`);//+ " " + (val.mvli_ledger_legal_name == null ? '' ? val.mvli_ledger_legal_name)
    }

    const copyDetail = () => {
        $('.loader').show();
        // getTranAuditTrail(obj);
        Common.callApi(Common.apiLedgerView, [sid, "copyData", JSON.stringify(copyLedgerData)], result => {
            $(".loader").hide();
            setCopyMsgBoxYN(false);
            let resp = JSON.parse(result);
            setCopyMsgTextYN('')
            // setLedgerList(JSON.parse(result));
            fillEditForm(resp.account, resp.group);

        });
    }

    const handleTaxClass = (v) => {
        setLdgTaxclass(v);
        console.log("Tax Class Number is :", v.value);
        if (v.value == 2) {
            setLdgGstin("");
            setLdgGst("1");
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h1>Voucher Ledger View</h1>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    visiblePg === "" ?
                        <>
                            <Row>
                                <Col xs={3} >
                                    <Form.Group>
                                        <Form.Label>Type</Form.Label>
                                        <Select options={groupTypeOptions} value={listType} onChange={v => onChangeListType(v)} />
                                    </Form.Group>
                                </Col>
                                {listType.value === 'OTHER' &&
                                    <Col className='col-md-3 col-6'>
                                        <Form.Group>
                                            <Form.Label>Group<span className="text-danger">*</span></Form.Label>
                                            <AsyncSelect
                                                cacheOptions={false}
                                                defaultOptions={false}
                                                value={filterLdgGroup}
                                                getOptionLabel={e => e.label + ' '}
                                                getOptionValue={e => e.id}
                                                loadOptions={(search) =>
                                                    Picklist.fetchGroupPicklist(search, 'OTHER').then(options => {
                                                        // Add your new option here
                                                        const newOption = { id: '', label: 'All' };
                                                        return [newOption, ...options];
                                                    })
                                                }
                                                onInputChange={Picklist.handleInputChange}
                                                onChange={handleFilterLdgGroupValue}
                                            >
                                            </AsyncSelect>
                                        </Form.Group>
                                    </Col>
                                }
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Search <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type='text' placeholder='Search By Name Or Pan Or GST IN' maxLength="100" value={searchFilter}
                                            onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setSearchFilter)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            {/* <Row xs={9} >
                                {userUploadRight.add === '1' && (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") ?
                                    <>
                                        <span>
                                            <Badge bg="secondary" className="handCursor" onClick={downloadFormat}>Ledger Upload Format <FontAwesomeIcon icon={faDownload} /></Badge>
                                        </span>
                                    </> : null}
                            </Row> */}

                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Button className='buttonStyle' size='sm' variant='outline-primary' onClick={() => getLedgerList()}>List</Button>&nbsp;
                                    {
                                        userRight.add === "1" ?
                                            <>
                                                {/* <Button className='buttonStyle' size='sm' variant='outline-primary' onClick={() => addNewForm()}>Add New</Button>&nbsp; */}
                                            </>
                                            : null
                                    }
                                    <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => exportFile()}>Export</Button> &nbsp;
                                    {/* {
                                        userUploadRight.add === "1" && (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") && !showUploadButton ?
                                            <>
                                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => setShowUploadButton(!showUploadButton)}>Upload Data</Button> &nbsp;
                                            </>
                                            : null
                                    } */}
                                    &nbsp;
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {/* <Row>
                                {
                                    userUploadRight.add === '1' && showUploadButton === true && (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") ?
                                        <>
                                            <Col className='col-md-3 col-3'>
                                                <Form.Group controlId='uploadEntries'>
                                                    <Form.Label>File* (MAX 10MB)</Form.Label>
                                                    <Form.Control type='file' value={nFile} onChange={e => handleFileChange(e.target.value)} />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-2 col-2'>
                                                <Button style={{ marginTop: "33px" }} variant='outline-primary' className='buttonStyle' size='sm' onClick={() => uploadFile()}>Submit</Button>
                                            </Col>
                                        </>
                                        : null
                                }
                            </Row> */}
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table responsive striped bordered>
                                        <thead>
                                            <tr>
                                                <th>&nbsp;</th>
                                                <th>UCIC</th>
                                                <th>Ledger Name</th>
                                                <th>Legal Name</th>
                                                <th>Group Code</th>
                                                <th>Group Name</th>
                                                <th>Scope</th>
                                                <th>Status</th>
                                                {
                                                    (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") ? <>
                                                        <th className='auto-stretch'>Validity</th>
                                                    </> : null
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                ledgerList.map((item, index) => (
                                                    <>
                                                        <tr key={index}>
                                                            <td>
                                                                <span className='colorThemeBlue' onClick={() => fillEditForm(item.mvli_srno, item.mvli_group)}>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>&nbsp;
                                                                {
                                                                    (copyLedgerDataRight?.query === '1' && listType.value != "ALL") && <span className='colorThemeBlue' onClick={() => copyDetailHandler(item)}>
                                                                        <FontAwesomeIcon icon={faCopy} />
                                                                    </span>
                                                                }
                                                            </td>
                                                            <td>{item.mvli_srno}</td>
                                                            <td>{item.mvli_ledger_name}</td>
                                                            <td>{item.mvli_ledger_legal_name}</td>
                                                            <td>{item.mvli_group}</td>
                                                            <td>{item.mvg_group_name}</td>
                                                            <td>{item.mvli_scope === "G" ? "GLOBAL" : (item.mvli_scope === "O" ? "ONE" : "SELECTIVE")}</td>
                                                            <td>{item.mvli_status == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                                            {
                                                                (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") ? <>
                                                                    <td>{item.mvli_validity_dmy}</td>
                                                                </> : null
                                                            }
                                                        </tr>
                                                        <tr key={`hi+${index}`} >
                                                            <td colSpan={15}>
                                                                PAN: {item.mvli_pancard}, GSTIN: {item.mvli_gstin}
                                                            </td >
                                                        </tr>
                                                    </>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button size='sm' className='buttonStyle' variant='outline-primary' onClick={() => cancelConfirm()}>Back</Button>
                                    {/* &nbsp; */}
                                    {/* {
                                        (userRight.edit === "1" && visiblePg === 'E') || (userRight.add === "1" && visiblePg === 'A') ?
                                            <Button size='sm' className='buttonStyle' variant='outline-primary' onClick={() => saveData()}>Save</Button>
                                            : null
                                    } */}
                                    &nbsp;
                                    {(userRight.query === "1" && (visiblePg === 'Q' || visiblePg === 'E')) ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    &nbsp;
                                    {/* {
                                        (userRight.edit === "1" && visiblePg === 'Q') ?
                                            <Button size='sm' className='buttonStyle' variant='danger' onClick={() => editFields()}>Edit</Button>
                                            : null
                                    } */}

                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Tabs>
                                <Tab eventKey="INFO" title="Info">
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>UCIC &nbsp;{ldgblacklisted === "1" ? <span><Badge bg='danger'>Blacklisted .Activation till Date :  {(ldgActivationTillDate === "" || ldgActivationTillDate === null) ? "Not activated" : ldgActivationTillDate}</Badge></span> : null}</Form.Label>
                                                <Form.Control disabled={true} value={ldgSrno} onChange={e => setLdgSrno(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            {/* <Form.Group>
                                                <Form.Label>Group</Form.Label>
                                                <Select isDisabled={disableGroupOptions} options={ldgGroupOptions} value={ldgGroup} onChange={v => setLdgGroup(v)} />
                                            </Form.Group> */}
                                            <Form.Group>
                                                <Form.Label>Group<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    isDisabled={disableGroupOptions}
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={ldgGroup}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={(search) => Picklist.fetchGroupPicklist(search, (listType.value))}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleLdgGroupValue}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Ledger Name<span className="text-danger">*</span></Form.Label>
                                                <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Name' maxLength="100" value={ldgName}
                                                    onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setLdgName)}
                                                />
                                            </Form.Group>
                                        </Col>
                                        {listType.value === "AGENT" || listType.value === "BANK" || listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "ISSUER" || listType.value === "OTHER" ?
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Legal Name</Form.Label>
                                                    <Form.Control disabled={isApiCalled === '1' || visiblePg === 'Q'} type='text' placeholder='Legal Name' maxLength="100" value={ldgLegalName}
                                                        onChange={(e) => Common.validateAlpNumSplValue(e.target.value, setLdgLegalName)}
                                                    />
                                                </Form.Group>
                                            </Col> : null};
                                    </Row>
                                    {listType.value == 'BANK' &&
                                        <Row>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Bank</Form.Label>
                                                    <Select isDisabled={visiblePg === 'Q'} options={ldgBankOptions} value={ldgBank} onChange={(v) => handleBankChange(v)} />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Account Number<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Account Number' maxLength="20" value={bankAccNo}
                                                        onChange={(e) => setBankAccNo(e.target.value)}
                                                        onBlur={(e) => Common.validateNumValue(e.target.value, setBankAccNo)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>IFSC Code<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='IFSC Code' value={bankIfsc}
                                                        maxLength={11}
                                                        onBlur={(e) => Common.validateIFSC(e.target.value, setBankIfsc)}
                                                        onChange={(e) => setBankIfsc(e.target.value)}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col></Col>
                                            <Col></Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Address{listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT" ? <span className="text-danger">*</span> : null}</Form.Label>
                                                <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Address' maxLength="200" value={ldgAddress} onChange={e => setLdgAddress(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Country{listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT" ? <span className="text-danger">*</span> : null}</Form.Label>
                                                <Select isDisabled={visiblePg === 'Q'} options={ldgCountryOptions} value={ldgCountry} onChange={v => handleCountryChange(v)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>State{(ldgCountry.value == 1) && (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") ? <span className="text-danger">*</span> : null}</Form.Label>
                                                <Select isDisabled={visiblePg === 'Q'} options={ldgStateOptions} value={ldgState} onChange={v => handleStateChange(v)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>District{(ldgCountry.value == 1) && (listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT") ? <span className="text-danger">*</span> : null}</Form.Label>
                                                <Select isDisabled={visiblePg === 'Q'} options={ldgDistrictOptions} value={ldgDistrict}
                                                    onChange={v => handleDistrictChange(v)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>City</Form.Label>
                                                <Select isDisabled={visiblePg === 'Q'} options={ldgCityOptions} value={ldgCity} onChange={v => setLdgCity(v)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Pin Code{listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER" || listType.value === "AGENT" ? <span className="text-danger">*</span> : null}</Form.Label>
                                                <Form.Control disabled={visiblePg === 'Q'} placeholder='Pin Code' type='text' maxLength={6} value={ldgPinCode} onChange={e => Common.validateNumValue(e.target.value, setLdgPinCode)} />
                                            </Form.Group>
                                        </Col>
                                        {
                                            listType.value === "DEALER" ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Dealer Type<span className="text-danger">*</span></Form.Label>
                                                            <Select isDisabled={visiblePg === 'Q'} options={ldgDealerOptions} value={ldgDealer} onChange={v => setLdgDealer(v)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>RBI License<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control disabled={visiblePg === 'Q'} type='text' maxLength={100} value={ldgRbiLicense} onChange={e => setLdgRbiLicense(e.target.value)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>RBI License Date<span className="text-danger">*</span></Form.Label>
                                                            <DatePicker
                                                                className="form-control"
                                                                selected={ldgRbiLicenseDate}
                                                                onChange={(date) => setLdgRbiLicenseDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                disabled={visiblePg === 'Q'}
                                                                minDate={new Date()}
                                                                customInput={
                                                                    <input
                                                                        type="text"
                                                                        size='sm'
                                                                        onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}
                                                                    />
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                </> : null
                                        }
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Last Review<span className="text-danger">*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={ldgLastReviewDate}
                                                    onChange={(date) => setLdgLastReviewDate(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={visiblePg === 'Q'}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Website</Form.Label>
                                                <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Website' maxLength="100" value={ldgWebsite} onChange={e => setLdgWebsite(e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Validity<span className="text-danger">*</span></Form.Label>
                                                <DatePicker className="form-control"
                                                    selected={ldgValidity}
                                                    onChange={(date) => setLdgValidity(date)}
                                                    dateFormat="dd/MM/yyyy"
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    useShortMonthInDropdown
                                                    dropdownMode="select"
                                                    peekNextMonth
                                                    disabled={visiblePg === 'Q'}
                                                    customInput={
                                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                    }
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Scope<span className="text-danger">*</span></Form.Label>
                                                <Form.Select value={ldgScope} disabled={scoperChangeRight?.query == '0' || visiblePg === 'Q'} onChange={e => setLdgScope(e.target.value)}>
                                                    <option value="">Select</option>
                                                    <option value="G">Global</option>
                                                    <option value="S">{listType.value === "BANK" ? "One" : "Selective"}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {
                                            listType.value === "BANK" && ldgScope === 'S' ?
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={bankLocationValue}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleChangeBankLocation}
                                                            isDisabled={visiblePg !== 'A'}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                                : null
                                        }
                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Status</Form.Label>
                                                <Form.Select value={ldgStatus} disabled={visiblePg === 'Q'} onChange={e => setLdgStatus(e.target.value)}>
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        {listType.value === 'ISSUER' ? <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Mvli Card</Form.Label>
                                                <Form.Select value={ldgMvliCard} disabled={visiblePg === 'Q'} onChange={e => setLdgMvliCard(e.target.value)}>
                                                    <option value="1">Active</option>
                                                    <option value="0">Inactive</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col> : null}
                                        {
                                            //ledger 5 -> FRANCHISEE, ledger 7 -> SERVICE PROVIDER
                                            (listType.value == "OTHER") ?
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>TDS(%)</Form.Label>
                                                        {/* <Form.Control disabled={visiblePg === 'Q'} type="text" value={ldgTds} 
                                                                onChange={e => Common.validateDecValue(e.target.value, setLdgTds)} /> */}
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={asyncTdsVal}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={Picklist.fetchTdsList}
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={tdsHandler}
                                                            formatOptionLabel={Picklist.tdsFormatOptionLabel}
                                                            components={{ Menu: Picklist.tdsMenu }}
                                                            isDisabled={visiblePg === 'Q'}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col> :
                                                null
                                        }
                                    </Row>
                                    <Row>

                                        {(listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "DIVISION") ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>CIN Number</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='CIN Number' maxLength="50" value={fxCINNumber} onChange={e => setFxCINNumber(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                            </> : null
                                        }
                                        <Col className='col-md-3 col-6'>
                                            {
                                                /*
                                                    <Form.Group>
                                                        <Form.Label>Fx Group</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='number' placeholder='Fx Group Number' maxLength="20" value={fxGroup} onChange={e => setFxGroup(e.target.value)} />
                                                    </Form.Group>
                                                */
                                            }

                                        </Col>
                                        <Col className='col-md-3 col-6'>
                                            {
                                                /*
                                                                                        <Form.Group>
                                                                                                <Form.Label>Fx Account</Form.Label>
                                                                                                <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Fx Account Number' maxLength="20" value={fxAccount} onChange={e => setFxAccount(e.target.value)} />
                                                                                            </Form.Group>
                                                
                                                                                        */
                                            }

                                        </Col>
                                    </Row>
                                </Tab>
                                {
                                    listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "AGENT" || listType.value === "OTHER" ?
                                        <Tab eventKey="TAXATION" title="Taxation">
                                            <Row>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>PAN Card<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' maxLength="10" placeholder='Pan' value={ldgPan}
                                                            onChange={e => setLdgPan(e.target.value)}
                                                            onBlur={(e) => Common.validatePan(e.target.value, setLdgPan)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Inception Date<span className="text-danger">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={ldgInceptionDate}
                                                            onChange={(date) => setLdgInceptionDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            disabled={visiblePg === 'Q'}
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    //ledger 5 -> FRANCHISEE, ledger 7 -> SERVICE PROVIDER
                                                    (listType.value == "OTHER") || (listType.value == "AGENT") || (listType.value == "DEALER" && ldgDealer.value == 5) || (listType.value == "DEALER" && ldgDealer.value == 7) ?
                                                        <Col className='col-md-3 col-6'>
                                                            <Form.Group>
                                                                <Form.Label>TDS(%)</Form.Label>
                                                                {/* <Form.Control disabled={visiblePg === 'Q'} type="text" value={ldgTds} 
                                                                onChange={e => Common.validateDecValue(e.target.value, setLdgTds)} /> */}
                                                                <AsyncSelect
                                                                    cacheOptions={false}
                                                                    defaultOptions={false}
                                                                    value={asyncTdsVal}
                                                                    getOptionLabel={e => e.label + ' '}
                                                                    getOptionValue={e => e.id}
                                                                    loadOptions={Picklist.fetchTdsList}
                                                                    onInputChange={Picklist.handleInputChange}
                                                                    onChange={tdsHandler}
                                                                    formatOptionLabel={Picklist.tdsFormatOptionLabel}
                                                                    components={{ Menu: Picklist.tdsMenu }}
                                                                    isDisabled={visiblePg === 'Q'}
                                                                >
                                                                </AsyncSelect>
                                                            </Form.Group>
                                                        </Col> :
                                                        null
                                                }
                                                {(listType.value === 'CORPORATE' || listType.value === 'DIVISION' || listType.value === 'WALKIN') ? <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Service Charge</Form.Label>
                                                            <Form.Select disabled={visiblePg === 'Q'} value={ldgServiceCharge} onChange={e => setLdgServiceCharge(e.target.value)}>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        ldgServiceCharge === "1" ?
                                                            <Col className='col-md-3 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Service Charge Amount</Form.Label>
                                                                    <Form.Control disabled={visiblePg === 'Q'} value={ldgServiceChargeVal} onChange={e => setLdgServiceChargeVal(e.target.value)} />
                                                                </Form.Group>
                                                            </Col>
                                                            : <Col className='col-md-3'>&nbsp;</Col>
                                                    }
                                                </> : null}
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Tax Class<span className="text-danger">*</span></Form.Label>
                                                        <Select isDisabled={visiblePg === 'Q'} options={ldgTaxclassOptions} value={ldgTaxclass}
                                                            // onChange={v => setLdgTaxclass(v)}
                                                            onChange={handleTaxClass}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>
                                                            GSTIN{ldgTaxclass?.value == 1 || ldgTaxclass?.value == 4 || ldgTaxclass?.value == 3 ?
                                                                <>
                                                                    <span className="text-danger">*</span>
                                                                    <span style={{ fontSize: "14px", display: visiblePg === "A" && "none" }}>&nbsp;&nbsp;{gstinVerifyTimestamp === "" ?
                                                                        <span><Badge bg='danger'>Not Verified</Badge> {visiblePg === "E" && <span onClick={verifyGstin} style={{ textDecoration: "underline", cursor: "pointer" }}>click to verify</span>}</span>
                                                                        : <Badge bg='success'>Verified {gstinVerifyTimestamp}</Badge>}</span>
                                                                </>
                                                                : null}
                                                        </Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q' || ldgTaxclass?.value == 2} type='text' maxLength="15" placeholder='GstIn' value={ldgGstin}
                                                            onChange={e => setLdgGstin(e.target.value)}
                                                            onBlur={(e) => Common.validateGST(e.target.value, setLdgGstin)} />
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    (listType.value === "CORPORATE" || listType.value === "DIVISION") &&
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>GST</Form.Label>
                                                            <Form.Select disabled={visiblePg === 'Q' || ldgTaxclass?.value == 2} value={ldgGst} onChange={e => setLdgGst(e.target.value)}>
                                                                <option value="">Select</option>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                }
                                                {
                                                    ldgGst === "0" &&
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Gst Exemption Till{ldgGst === "0" ? <span className="text-danger">*</span> : null}</Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={ldgGstExemptionDate}
                                                                onChange={(date) => setLdgGstExemptionDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                disabled={visiblePg === 'Q'}
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                }
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>ARN</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' maxLength="23" placeholder='ARN' value={ldgARN} onChange={e => setLdgARN(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>UIN</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' maxLength="15" placeholder='UIN' value={ldgUIN} onChange={e => setLdgUIN(e.target.value)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Aadhar Card</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' maxLength="12" placeholder='Aadhar Num' value={ldgAadhar} onChange={e => Common.validateNumValue(e.target.value, setLdgAadhar)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        {
                                                            /*
                                                                {listType.value === "CORPORATE" ? <span className="text-danger">*</span> : null}
                                                            */
                                                        }
                                                        <Form.Label>MSME</Form.Label>
                                                        <Select isDisabled={visiblePg === 'Q'} options={ldgMSMEOptions} value={ldgMSME} onChange={v => setLdgMSME(v)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        : null
                                }
                                {/* {
                                    listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "AGENT" ?
                                        <Tab eventKey="RISK" title="Risk">
                                            <Row>
                                                {(listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "DIVISION") ? <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>Credited Allowed</Form.Label>
                                                            <Form.Select disabled={visiblePg === 'Q'} value={ldgCreditAllow} onChange={e => setLdgCreditAllow(e.target.value)}>
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        ldgCreditAllow === "1" ?
                                                            <>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Credit Limit</Form.Label>
                                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Limit' maxLength="10" value={ldgCreditLimit} onChange={e => Common.validateNumValue(e.target.value, setldgCreditLimit)} />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col className='col-md-3 col-6'>
                                                                    <Form.Group>
                                                                        <Form.Label>Credit Period</Form.Label>
                                                                        <Form.Control disabled={visiblePg === 'Q'} placeholder='Credit Period' type='text' maxLength="10" value={ldgCreditPeriod} onChange={e => Common.validateNumValue(e.target.value, setldgCreditPeriod)} />
                                                                    </Form.Group>
                                                                </Col>
                                                            </> : null
                                                    }
                                                </> : null}
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Risk<span className="text-danger">*</span></Form.Label>
                                                        <Select isDisabled={visiblePg === 'Q'} options={ldgRiskOptions} value={ldgRisk} onChange={v => setLdgRisk(v)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Expected volume low</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Volume low' value={ldgExpectedVolLow} onChange={e => Common.validateDecValue(e.target.value, setLdgExpectedVolLow)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Expected volume medium
                                                            {(listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER") ? <span className="text-danger">*</span> : null}
                                                        </Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Volume medium' value={ldgExpectedVolMedium} onChange={e => Common.validateDecValue(e.target.value, setLdgExpectedVolMedium)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Expected volume high
                                                            {(listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "DEALER") ? <span className="text-danger">*</span> : null}
                                                        </Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Volume high' value={ldgExpectedVolHigh} onChange={e => Common.validateDecValue(e.target.value, setLdgExpectedVolHigh)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Legal Status{(listType.value === "CORPORATE" || listType.value === "DIVISION") ? <span className="text-danger">*</span> : null}</Form.Label>
                                                        <Select isDisabled={visiblePg === 'Q'} options={ldgLegalOptions} value={ldgLegalStatus} onChange={v => setLdgLegalStatus(v)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Nature of Business{(listType.value === "CORPORATE" || listType.value === "DIVISION") ? <span className="text-danger">*</span> : null}</Form.Label>
                                                        <Select isDisabled={visiblePg === 'Q'} options={ldgNatureStatusOptions} value={ldgNatureStatus} onChange={v => setLdgNatureStatus(v)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        : null
                                } */}
                                {/* {
                                    listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "DIVISION" || listType.value === "AGENT" ?
                                        <Tab eventKey="ADDITIONAL" title="Additional">
                                            <Row>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Phone{((listType.value === "CORPORATE") || (listType.value === "DEALER") || (listType.value === "DIVISION")) ? <span className="text-danger">*</span> : null}</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Phone' maxLength={10} value={ldgPhone} onChange={e => Common.validateDecValue(e.target.value, setLdgPhone)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Mobile{((listType.value === "CORPORATE") || (listType.value === "DEALER") || (listType.value === "DIVISION")) ? <span className="text-danger">*</span> : null}</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Mobile' maxLength={10} value={ldgMobile} onChange={e => Common.validateDecValue(e.target.value, setLdgMobile)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Email{((listType.value === "CORPORATE") || (listType.value === "DIVISION") || (listType.value === "DEALER")) ? <span className="text-danger">*</span> : null}</Form.Label>
                                                        <Form.Control
                                                            disabled={visiblePg === 'Q'}
                                                            type='text'
                                                            placeholder='Email'
                                                            maxLength={100}
                                                            value={ldgEmail}
                                                            onChange={(e) => setLdgEmail(e.target.value.trim())}
                                                            onBlur={(e) => Common.validtateEmail(e.target.value.trim(), setLdgEmail)}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Listed In</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Listed In' maxLength={100} value={ldgListedIn} onChange={e => Common.validateAlpValue(e.target.value, setLdgListedIn)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Beneficiary Owner</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Bene Owner' maxLength={100} value={ldgBeneOwner} onChange={e => Common.validateAlpValue(e.target.value, setLdgBeneOwner)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Beneficiary Mobile</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Bene Mobile' maxLength={10} value={ldgBeneMobile} onChange={e => Common.validateNumValue(e.target.value, setLdgBeneMobile)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Account Manager</Form.Label>
                                                        <Select isDisabled={visiblePg === 'Q'} options={ldgAccManagerOptions} value={ldgAccManager} onChange={v => setLdgAccManager(v)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Bank Name</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Bank Name' maxLength={100} value={ldgBankName} onChange={e => Common.validateAlpValue(e.target.value, setLdgBankName)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Bank Account Number</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Bank acc num' maxLength={100} value={ldgBankAccNum} onChange={e => Common.validateNumValue(e.target.value, setLdgBankAccNum)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Source of Fund</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Source of fund' maxLength={100} value={ldgFundSource} onChange={e => Common.validateAlpValue(e.target.value, setLdgFundSource)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Payment Mode</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Payment Mode' maxLength={50} value={ldgPaymentMode} onChange={e => Common.validateAlpValue(e.target.value, setLdgPaymentMode)} />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>Social Status</Form.Label>
                                                        <Form.Control disabled={visiblePg === 'Q'} type='text' placeholder='Social Status' maxLength={100} value={ldgSocialStatus} onChange={e => Common.validateAlpValue(e.target.value, setLdgSocialStatus)} />
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Tab>
                                        : null
                                } */}
                                {/* {
                                    listType.value === "DEALER" || listType.value === "CORPORATE" || listType.value === "AGENT" ? 
                                     : null
                                } */}

                                {/* {
                                    ldgScope === 'S' && listType.value !== "BANK" && visiblePg != 'A' ?
                                        <Tab eventKey="LOCATION" title="Location">
                                            <Master_ledger_location ldggrpsrno={ldgGroup.value} ldgsrno={ldgSrno} visiblePg={visiblePg} locationLink={locationLink} />
                                        </Tab> : null
                                } */}
                                {/* {
                                    (listType.value === "AGENT" && (visiblePg == 'E' || visiblePg == 'Q')) ?
                                        <Tab eventKey="COMMISSION" title="Commission">
                                            <Master_ledger_commission deleteRight={userRight.delete} ldggrpsrno={ldgGroup.value} ldgsrno={ldgSrno} visiblePg={visiblePg} commissionList={commissionList} updateCommissionList={handleCommListUpdate} />
                                        </Tab>
                                        : null
                                } */}
                                {/* {
                                    (listType.value === "AGENT" || listType.value === "DEALER" || listType.value === "CORPORATE") && ldgSrno > 0 ?
                                        <Tab eventKey="DOCUMENTS" title="Documents">
                                            <Master_ledger_documents ldggrpsrno={ldgGroup.value} ldgsrno={ldgSrno} visiblePg={visiblePg} listType={listType.value} ledgerDocument={ledgerDocument} />
                                        </Tab>
                                        : null
                                } */}
                                {/* {
                                    listType.value === "WALKIN" ?
                                        <Tab eventKey="CREDITLIMIT" title="Credit Limit">
                                            <>
                                                {
                                                    visiblePg != 'Q' &&
                                                    <>
                                                        <Row className='walkinUpDownIconRemove'>
                                                            <Col className='col-md-4'>
                                                                <Form.Group>
                                                                    <Form.Label>Branch</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions={false}
                                                                        defaultOptions={false}
                                                                        value={crdLmtBranch}
                                                                        getOptionLabel={e => e.label + ' '}
                                                                        getOptionValue={e => e.id}
                                                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                                                        onInputChange={Picklist.handleInputChange}
                                                                        onChange={setCrdLmtBranch}
                                                                    >
                                                                    </AsyncSelect>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-4 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Credit Amount</Form.Label>
                                                                    <Form.Control
                                                                        value={crdLmtAmount}
                                                                        maxLength={Common.maximumLength}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setCrdLmtAmount)}
                                                                        type='number'
                                                                        placeholder="Credit Amount"
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            <Col className='col-md-4 col-6'>
                                                                <Form.Group>
                                                                    <Form.Label>Credit Days</Form.Label>
                                                                    <Form.Control
                                                                        value={crdLmtDays}
                                                                        maxLength={3}
                                                                        onChange={(e) => Common.validateNumValue(e.target.value, setCrdLmtDays)}
                                                                        type='number'
                                                                        placeholder="Credit Days"
                                                                    // disabled={scrMode === 'V' || (viewStatus !== 'P' && scrMode === 'E') || (srno != 0 && requesterName.split(' ')[0] !== userSrno)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        &nbsp;
                                                        <Row>
                                                            <Col>
                                                                <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={walkinCreditLimitListHandler}>Add</Button>
                                                            </Col>
                                                        </Row>
                                                        &nbsp;
                                                    </>
                                                }
                                                <Row>
                                                    <Col>
                                                        <Table responsive striped bordered>
                                                            <thead>
                                                                <tr>
                                                                    {visiblePg != 'Q' && <th>Action</th>}
                                                                    <th>Branch</th>
                                                                    <th>Credit Amount</th>
                                                                    <th>Credit  Days</th>
                                                                    <th>Created Date</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    walkinCreditLimitList?.map((item, index) => (
                                                                        (item?.isActive !== 0 ?
                                                                            <tr key={index}>
                                                                                {visiblePg != 'Q' &&
                                                                                    <td className="textCenter">
                                                                                        <span className="handCursor colorThemeBlue" onClick={() => deleteWalkinCreditItem(item.tempsrno)}>
                                                                                            {visiblePg != 'Q' && <FontAwesomeIcon icon={faTrash} />}
                                                                                        </span>{' '}
                                                                                    </td>}
                                                                                <td>{item.branch.label}</td>
                                                                                <td>{item.creditamount}</td>
                                                                                <td>{item.creditdays}</td>
                                                                                <td>{Common.dateDMY(item.creditdate) + ' ' + item.creditdate.toTimeString().split(' ')[0]}</td>
                                                                            </tr> : null
                                                                        )
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </>
                                        </Tab> : null
                                } */}
                            </Tabs>
                            <Row>&nbsp;</Row>
                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container >
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                {msgTextYN}
            </DialogYesNo>
            <DialogYesNo isOpen={isCopyMsgBoxYN} onYes={(e) => copyDetail()} onNo={(e) => setMsgBoxYN(false)}>
                {copyMsgTextYN}
            </DialogYesNo>
        </>
    )
}

export default Master_voucher_ledger_view
